import { useNavigate, useSearch } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Functies } from "@/features/stamgegevens/Functies";
import { BeheerderShell } from "@/components/BeheerderShell";
import { keepScrollPosition } from "@jbnl/shared-ui";

export function FunctiesPage() {
  const { t } = useTranslation(["paginas", "navigatie"]);
  const { functie: functieId } = useSearch({ from: "/stamgegevens/functies" });
  const navigate = useNavigate({ from: "/stamgegevens/functies" });

  return (
    <BeheerderShell
      titel={t("navigatie:paginas.functies.label")}
      uitleg={t("functies.uitleg")}
    >
      <Functies
        functieId={functieId}
        onKies={(id) =>
          void navigate({ ...keepScrollPosition, search: { functie: id } })
        }
      />
    </BeheerderShell>
  );
}
